import { AvatarGroup, Box } from "@mui/material";
import { EntityChip, type EntityType } from "./EntityChip";

export type EntityChipsProps = {
  type: EntityType;
  names: string[];
  max?: number;
  size?: "small" | "medium";
};

export const EntityChips = ({
  type,
  names,
  max = 4,
  size = "medium",
}: EntityChipsProps) => {
  return (
    <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
      <AvatarGroup
        max={max}
        sx={{
          "& .MuiAvatar-root": {
            width: size === "small" ? 24 : 32,
            height: size === "small" ? 24 : 32,
            fontSize: size === "small" ? "0.75rem" : "1rem",
          },
        }}
      >
        {names.map((name) => (
          <EntityChip key={name} type={type} name={name} iconOnly size={size} />
        ))}
      </AvatarGroup>
    </Box>
  );
};
